import Alert from "@amzn/awsui-components-react/polaris/alert";
import { MerchantConfigurationResponse } from "Api/useQueryMerchantConfiguration";
import KeyValuePairs from "@amzn/awsui-components-react/polaris/key-value-pairs";

const MerchantConfigurationPageResult = ({ response }: { response: MerchantConfigurationResponse }) => {
  if (!response.merchantId) {
    return <Alert type="success">Your merchant is now IBA eligible!</Alert>;
  }

  return (
    <Alert type="success">
      <h4>Here is your new IBA eligible merchant! Please save the details before refreshing this page</h4>
      <KeyValuePairs
        columns={1}
        items={[
          { label: "Merchant ID", value: response.merchantId },
          { label: "Email", value: response.email },
          { label: "Password", value: response.password },
        ]}
      />
    </Alert>
  );
};

export default MerchantConfigurationPageResult;
